import { HireReason } from 'types/hire-reason'

export const truncate = (value: string, limit: number, appendEllipsis?: boolean) => {
  if (!value) {
    return value
  }

  return `${value.substring(0, limit)}${appendEllipsis && limit < value.length ? '...' : ''}`
}
export const xmlEncodeString = (text: string) =>
  !!text ? text.replace(/[\u00A0-\u9999<>\&]/g, (c) => '&#' + c.charCodeAt(0) + ';') : text

export const generateReasonWithLinks = ({ reason, keywordLinks }: HireReason): string => {
  const tokens = reason.split(' ')
  const tokensWithLinks = tokens.map((token) => {
    const foundKeywordLink = Array.isArray(keywordLinks)
      ? keywordLinks.find(({ keyword }) => keyword === token)
      : undefined
    if (foundKeywordLink) {
      return `<a href='${foundKeywordLink.url}'>${foundKeywordLink.keyword}</a>`
    }
    return xmlEncodeString(token)
  })

  return tokensWithLinks.join(' ')
}

export const getListingFacetCopy = (label: string, text: string, supportingData: string) => {
  let copy = ''
  if (label && text) {
    copy = `${label}: ${text}`
  } else if (label) {
    copy = label
  } else if (text) {
    copy = text
  }
  copy += supportingData ? `\n${supportingData}` : ''
  return copy
}

export const capitalizeAllWords = (text: string) => {
  if (!text) {
    return text
  }

  const words = text.split(' ')
  const capitalizedWords = words.map((word) => word.charAt(0).toUpperCase() + word.substring(1))

  return capitalizedWords.join(' ')
}

export const getLocationCopy = (city: string, state: string): string =>
  [city, state].filter((copy) => !!copy).join(', ')

export const hasQueryString = (urlParts: string): boolean =>
  urlParts ? urlParts.indexOf('?') > -1 : false
